'use client';

import { JSX, useEffect, useRef } from 'react';

export function SignUpError({ error }: { error?: string }): JSX.Element | null {
    const errorRef = useRef<HTMLDivElement>(null);

    // Focus rather than a live region: VoiceOver missed the alert on the first submit.
    useEffect(() => {
        if (error) {
            errorRef.current?.focus();
        }
    }, [error]);

    if (!error) {
        return null;
    }
    return (
        <div ref={errorRef} tabIndex={-1} className="p-2 bg-red-50 border border-red-200 rounded py-2 px-3">
            <p className="text-sm text-red-600">{error}</p>
        </div>
    );
}
